import React, { useCallback, useEffect,useRef, useState, useReducer,  useContext } from 'react';

// Page Components:
import PageHeader  from './components/PageHeader/PageHeader';
import PageToolbar from './components/Toolbar/PageToolbar';
import PageContent from './components/PageContent/PageContent';
import PageSidebar from './components/PageSidebar/PageSidebar';
import PageFooter  from './components/PageFooter/PageFooter';

import CustomDialog from './components/UI Components/Dialogs/CustomDialog';
import CustomDrawer from './components/UI Components/Drawers/CustomDrawer';
import ScrollUpButton from './components/UI Components/Buttons/ScrollUpButton';

// MUI Components
import Box from '@mui/material/Box';
import Container  from '@mui/material/Container';
import Grid       from '@mui/material/Grid';


// Context
import { FilterProvider, useFilter } from './Context/FilterCountext';
import { ObjListProvider } from './Context/ObjectListContext';
import { UserProvider } from './Context/UserContext';
import { FavoriteProvider } from "./Context/FavoritesContext";
import { AppDataProvider, useAppData } from './Context/AppDataContext';
import {useAuthData,useAuthDispatch} from './Context/AuthContext';

// utils
import RouteTracker from './utility/routeTrack';
import { handleCompDisplay } from './utility/utils';

// Theme
// import { useTheme } from '@mui/material/styles';

// translation:
import { useTranslation } from 'react-i18next';

// router
import { useLocation } from 'react-router';

// model
import { getUserInfo, refresh } from './models/userModel';
import Login from './routes/Login/Login';

// custom hooks
// import useScreenSize from './custonHooks/useScreenSize';


function App() {

  console.log("RENDER APP");

    const { t, i18n }    = useTranslation(),
          filterSetting  =  useFilter(),
          appData        = useAppData(),
          location       = useLocation(),
          authData       = useAuthData();

    const [currObjId, setCurrObjId ]        = useState(null);
    const [drawerOpen, setDrawerOpen]       = useState(false);
    const [sDrawerParam, setDrawerParam]    = useState(null);

    const [dialogSttng,setDialogSttng] =  useState({
      bDialogOpen: false,
      sDialogParam: '',
      bFullScreen: false
    })

    
  // Authentication
    const authDispatch = useAuthDispatch();


  /**  State Handling
   *******************************************************/

    useEffect( () => {

      const _getUserInfo = async() => {

        let oResp = await getUserInfo();

            if(oResp.status === 200) {
              await authDispatch({type: 'setCurrUser', oUserData: oResp.data});
            }

            if(oResp.status === 401 ) { // token exprired no found
              _refreshSession();
            }
            
            if(oResp.status === 404) {
              await authDispatch({type: 'logout',  oUserData: null});
              
            }
      }

      const _refreshSession = async () => {

        try {
          let data;
              data = await refresh();
                    await authDispatch({type: 'setCurrUser', oUserData: data});
        } catch(e) {

            await authDispatch({type: 'logout',  oUserData: null});
            alert('error refrsh user session');

        }
      }

      _getUserInfo();

      // RouteTracker();
        
    },[authDispatch])


  /**  Event Handling:
   *******************************************************/

  //Filter Dialog
  const onFilterClick = (sParam, oEvent) => {
      // console.log(filterSetting, 'curr filter sitting')
      setDrawerParam(sParam);
      setDrawerOpen(true);
  }

  //ObjectDetail Drwaer
  const onObjDetailPress  = (sParam, sObjectId, oEvent) => { 
      setDrawerParam(sParam);
      setDrawerOpen(true);
      setCurrObjId(sObjectId);
  }

  // User LogIn
  const onUserLogin = (oEvent,sParam) => {
      let nDlgSetting = {...dialogSttng, bDialogOpen: true, sDialogParam: 'usrLgn', bFullScreen: false}
      setDialogSttng(nDlgSetting);
  }

  const updateCurrObject = (id) => { setCurrObjId(id); };
  
  return (
     
    <AppDataProvider>
    <RouteTracker/>
    <FavoriteProvider>
    <FilterProvider>
    <ObjListProvider>
    <UserProvider>

    <Box>
      <ScrollUpButton></ScrollUpButton>

    {
      !authData.isAuthenticated
      ?
        <Login></Login>
      :
        <Grid container
              spacing={{xs:0.3, md:0.3, lg:2, xl:2}} 
              sx={{ 
                backgroundColor:'#f4f4f4',
                maxWidth:1024,
                marginLeft:'auto',
                marginRight:'auto'
              }}>

      {/* Header */}
            {/* display={location.pathname === '/login' ? 'none' : 'block' }  */}
          <Grid size={{ xs: 12, md: 12, lg:12}}>
            <Container disableGutters
              sx={ { 
                  height : '2.5rem',
                  width  : '100%',
                  padding:0,
                  backgroundColor:'#f4f4f4',

                  "@media (min-width:1024px) and (max-width:1280px)" : {
                      width: '100%',
                      maxWidth: 1200,
                      paddingLeft:0,
                      paddingRight:0
                  },
                  "@media screen and (min-width:1280px)" : {
                      width: '100%',
                      maxWidth: 1200,
                      paddingLeft:0,
                      paddingRight:0
                  }  
              }} >
              <PageHeader onUserLogin={onUserLogin}/>
            </Container>
          </Grid>

      {/* Toolbar */}
        <Grid size={{ xs: 12, md: 12, lg:12}} >
            <Container 
              disableGutters 
              sx={ {
                  marginTop:'1rem',
                  height : '2.5rem',
                  width  : '100%',
                  padding:0,
                  "@media (min-width:1024px) and (max-width:1280px)" : {
                      width: '100%',
                      maxWidth: 1200,
                      paddingLeft:0,
                      paddingRight:0,
                      display:'none'
                  },
                  "@media screen and (min-width:1280px)" : {
                      width: '100%',
                      maxWidth: 1200,
                      paddingLeft:0,
                      paddingRight:0,
                      display:'none'
                    }  
              }} >
              <PageToolbar onFilterClick={onFilterClick}/>
            </Container>
        </Grid>

      {/* SideBar */}
          <Grid size={{ xs: 0, md: 0, lg:4, xl:4 }}
                sx={{
                  border:'3px groove',
                  display:{ xs:'none',
                          md:'none',
                          lg: handleCompDisplay('sideBar',location.pathname),
                          xl: handleCompDisplay('sideBar',location.pathname)
                          }
          }}>

            <Container xs={{ marginTop:'1rem' }}>
              <PageSidebar/>
            </Container>

          </Grid>

      {/* CONTENT */}
          <Grid size={{ xs: 12, md: 12, lg:8, xl:8 }}>
            <Container >
                  {/* <PageContent onFavDeletePress={onFavDeletePress} onFavoritePress={onFavoritePress} favoriteList={favoriteList}/> */}
                  <PageContent onObjDetailPress={onObjDetailPress}/>

                <CustomDialog
                    dialogSttng={dialogSttng}
                    handleDlgClose={() =>setDialogSttng({...dialogSttng, bDialogOpen:false})}>
                </CustomDialog>

              <CustomDrawer
                  // handleDrawerOpen={handleDrawerOpen}
                  onFilterClose={() => setDrawerOpen(false)}
                  sParam={sDrawerParam}
                  openDrawer={drawerOpen}
                  closeDrawer={() => setDrawerOpen(false)}
                  currObjId={currObjId}/>

            
                  
            </Container>
          </Grid>

      {/* FOOTER */}
            <Grid size={{ xs: 12, md: 12, lg:12 }}>
              <Container 
                disableGutters
                sx={ {
                    border:'solid',
                    zIndex:3,
                    position: 'fixed',
                    width:'100%',
                    maxWidth: 1024,
                    ml: 'auto',
                    mr: 'auto',
                    justifySelf:'Center',
                    bottom: 0,
                    height:'auto'
                } }>
                {/* <BottomNav favoriteList={favoriteList} favoriteCount={favoriteCount} ></BottomNav> */}
                {/* <PageFooter onFilterClick={onFilterClick}/> */}
            </Container>
            </Grid>       
        </Grid>  
     } 
     </Box>   
    </UserProvider>    
    </ObjListProvider>
  </FilterProvider>
  </FavoriteProvider>
  </AppDataProvider>
  
  );
}

export default App;
